import { useSyncExternalStore } from "react";

import { subscribeToConnectionState } from "../wsNativeApi";
import type { WsTransportState } from "../wsTransport";

let currentState: WsTransportState = "connecting";
let started = false;
const subscribers = new Set<() => void>();

function ensureStarted() {
  if (started) {
    return;
  }
  started = true;
  subscribeToConnectionState((state) => {
    currentState = state;
    for (const notify of subscribers) {
      notify();
    }
  });
}

function subscribe(onStoreChange: () => void): () => void {
  ensureStarted();
  subscribers.add(onStoreChange);
  return () => {
    subscribers.delete(onStoreChange);
  };
}

function getSnapshot(): WsTransportState {
  return currentState;
}

/**
 * Current WebSocket connection state.
 *
 * The transport subscription is shared across every caller and never torn down:
 * the connection outlives any single component, and re-subscribing on each
 * mount would make the state flicker back to "connecting" on remount.
 */
export function useConnectionState(): WsTransportState {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
